import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { hasReportsAccess, UserService } from '../pages/admins/user.service';

export const reportsAccessGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const user = userService.currentUser();
  if (user && hasReportsAccess(user)) {
    return true;
  }

  const returnUrl = router.url && router.url !== '/' && router.url !== '/forbidden' ? router.url : '/invoices';
  return router.createUrlTree(['/forbidden'], {
    queryParams: { reason: 'access-denied', returnUrl },
  });
};
